import SkeletonLoader from './index';

const AssignedClassesPageSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* Search */}
      <SkeletonLoader width={280} height={44} className="rounded-lg" />

      {/* Title */}
      <SkeletonLoader width={180} height={26} />

      {/* Class Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="rounded-2xl p-6 flex flex-col gap-6 bg-neutral-100"
          >
            <div className="flex items-center gap-2">
              <SkeletonLoader
                variant="rect"
                width={34}
                height={34}
                className="rounded-lg"
              />
              <SkeletonLoader width={100} height={22} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <SkeletonLoader height={64} className="rounded-lg" />
              <SkeletonLoader height={64} className="rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignedClassesPageSkeleton;
